import { FunctionComponent } from "react";

import "./index.scss";

export const Footer: FunctionComponent = () => {
  return (
    <div id="footer-wrapper">
      <div id="footer">
        <div id="lipsum">
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum
            vestibulum sed ante ac rutrum. Sed maximus sapien non odio euismod
            suscipit. Sed sodales posuere posuere. Curabitur eu mattis sapien.
            Integer porttitor sapien mi, in ornare enim fermentum non. Etiam
            vitae venenatis arcu. Suspendisse euismod lacinia tellus eget
            pharetra.
          </p>
          <p>
            In scelerisque, ante id consectetur tincidunt, lorem augue maximus
            lorem, vel lobortis dui erat eget sapien. Sed sed eleifend augue.
            Orci varius natoque penatibus et magnis dis parturient montes,
            nascetur ridiculus mus. Nam convallis, eros id commodo pellentesque,
            est metus ullamcorper odio, at vehicula magna felis in mauris.
            Aenean tempor est eu finibus consectetur. Morbi eu quam nec magna
            viverra tempor. Praesent vel turpis lobortis, porttitor enim ac,
            consectetur nulla. Curabitur justo odio, malesuada quis aliquam
            eget, mattis at dolor. Ut non nisl nec risus ullamcorper faucibus.
            In posuere sed tellus in euismod. Morbi interdum ultricies libero
            nec consequat. Vivamus sit amet risus sapien. Etiam fringilla dolor
            ante, lacinia volutpat ligula blandit ac. Proin eget fringilla ante.
            Nunc euismod vel orci non dictum. Aenean nisl velit, lacinia vel
            neque non, maximus hendrerit ipsum.
          </p>
          <p>
            Etiam non velit placerat, consequat magna quis, sagittis nulla.
            Integer blandit erat et quam commodo blandit. Sed orci purus,
            fringilla vel libero id, fermentum placerat magna. Vivamus finibus
            pretium vehicula. Ut imperdiet nulla sed sem tempor, eget pulvinar
            diam feugiat. Nulla facilisi. Suspendisse metus nunc, suscipit eget
            tempor in, aliquet eu massa.
          </p>
        </div>
      </div>
    </div>
  );
};
